import * as React from "react";
import { LineChart } from "@mui/x-charts/LineChart";
import axios from "axios";

export default function DailyAverageSpeedChart() {
  const [chartData, setChartData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
 const restaurantId = sessionStorage?.getItem("store_id") || "Null";
  React.useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          `/server/dashboard-functions/daily-average-speed/${restaurantId}`
        );
   setLoading(false);
      if (res.data.success) {
     
  const { labels, totalEventOrderDuration, totalWindowDuration } =
    res.data.data;

  // --- calculate 7-day average ---
  const sum = totalEventOrderDuration.reduce((acc, v) => acc + v, 0);
  const sevenDayAvg =
    totalEventOrderDuration.length > 0 ? sum / totalEventOrderDuration.length : 0;
  const sevenDayAvgLine = Array(labels.length).fill(sevenDayAvg.toFixed(2));

  setChartData({
    labels,
    series: [
      {
        data: totalEventOrderDuration,
        label: "Event Order Duration",
        color: "#761600",
        showMark: true,
      },
      {
        data: totalWindowDuration,
        label: "Window Duration",
        color: "#8e24aa",
        showMark: true,
      },
      {
        data: sevenDayAvgLine,
        label: `7-Day Average (${sevenDayAvg.toFixed(2)})`,
        color: "#f57c00",
        curve: "linear",
        showMark: false,
      },
    ],
  });
}
else {
          throw new Error("API returned success: false");
        }
      } catch (err) {
        console.error("Chart fetch error:", err);
        setError(err.message || "Error loading chart data");
      }
    };

    fetchData();
  }, []);
const Loader = () => (
    <div className="flex justify-center items-center h-full min-h-[300px]">
        <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-[#E57320]  border-solid"></div>
    </div>
);
 
  if (loading) return <Loader />;
  if (error) return <p className="text-red-600">Error: {error}</p>;
  if (!chartData) return <p>Loading chart...</p>;

  return (
    <>
      <div className="mb-4">
        <p className="text-2xl text-gray-800">Daily Speed vs. 7-Day Average</p>
      </div>

      <LineChart
        height={400}
        series={chartData.series}
        xAxis={[
          {
            scaleType: "point",
            data: chartData.labels,
          },
        ]}
        yAxis={[
          {
            label: "Speed",
            valueFormatter: (value) => value.toFixed(2),
            
          },
        ]}
        slotProps={{
          legend: {
            direction: "row",
            position: { vertical: "top", horizontal: "middle" },
            labelStyle: { fontSize: 10 },
          },
        }}
        grid={{ vertical: true, horizontal: true }}
      />
    </>
  );
}
